module.exports = __webpack_public_path__ + "static/entrance-1.8c125c12.png";